import { backofficeClient } from 'services/backofficeIntegration/http/client/createBackofficeClient';
import { mutationEndpoint } from 'services/backofficeIntegration/http/endpointDefinition';

export const markNotificationAsRead = mutationEndpoint({
  async callEndpoint(props: { notificationId: string }) {
    await backofficeClient.post(`/notifications/${props.notificationId}/mark-as-read`);
  }
});
